import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const multiSelectCSS = css({
  height: "40px",
  padding: `0 ${vars.spacing[3]}`,

  outlineWidth: "1px",
  outlineStyle: "solid",
  outlineOffset: "-1px",

  outlineColor: vars.semantic.color.border,

  borderRadius: vars.rounded.medium,

  backgroundColor: vars.semantic.color.surface,

  "&:not(:has(input:disabled), :disabled):hover": {
    outlineColor: vars.semantic.color.borderHover,
  },

  "&:not(:has(input:disabled)):focus, &:has(input:focus)": {
    outlineColor: vars.semantic.color.focus,
  },

  "&:has(input:disabled)": {
    backgroundColor: vars.semantic.color.fieldDisabled,
    outlineColor: "transparent",
  },

  "&:disabled": {
    backgroundColor: vars.semantic.color.fieldDisabled,
    outlineColor: "transparent",
  },
});

export const selectTagCSS = css({
  flex: "none",

  gap: vars.spacing[1],
  alignItems: "center",

  paddingLeft: vars.spacing[2],
  paddingTop: vars.spacing[15],
  paddingBottom: vars.spacing[15],
  paddingRight: vars.spacing[1],

  backgroundColor: vars.semantic.color.surfaceSub,

  borderRadius: vars.rounded.full,

  "&:hover": {
    backgroundColor: vars.semantic.color.actionSecondaryHover,

    ".clay-tag-button": {
      color: vars.semantic.color.iconCritical,
    },
  },

  "&:active": {
    backgroundColor: vars.semantic.color.actionSecondaryPressed,
  },
});
